var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"calc(100% - 8px)","width":"100%"}},[_c('iframe',{attrs:{"src":_vm.src,"width":"100%","height":"100%","frameborder":"0","scrolling":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }